/*
 * ElectricBot
 * @url https://electricbot.com/
 * @copyright Electricbot, LLC. ©  2020
 */

// APP IMPORTS
import "@/assets/scss/main.scss";
import "ant-design-vue/dist/antd.css";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import CKEditor from "@ckeditor/ckeditor5-vue";
import { store } from "@/store";
import CheckboxRadio from "vue-checkbox-radio";
import Vuelidate from "vuelidate";
import Vue2Filters from "vue2-filters";
import VueViewer from "v-viewer";
import vuetify from "./plugins/vuetify";
import Antd from "ant-design-vue";

// Roles
import Roles from "./roles";
import Priviledged from "./roles/priviledged";
import ROLES from "./roles/roles";

// Helpers
import "./helpers/filters";
import "./helpers/cmp";
import { isMobile, isMobileOnly, isTablet } from "mobile-device-detect";
import { sanitizer } from "./plugins/sanitizer";
// Vue.use(DatetimePicker)

Vue.config.productionTip = false;

Vue.prototype.$checkRole = Roles;
Vue.prototype.$hasPriviledge = Priviledged;

Vue.use(Vuelidate);
Vue.use(CKEditor);
Vue.use(CheckboxRadio);
Vue.use(Vue2Filters);
Vue.use(VueViewer);
Vue.use(Antd);
Vue.directive("sanitizer", {
  inserted(el, binding) {
    const htmlContent = binding.value || "";
    el.innerHTML = sanitizer(htmlContent);
  },
  update(el, binding) {
    const htmlContent = binding.value || "";
    el.innerHTML = sanitizer(htmlContent);
  },
});

Vue.mixin({
  data() {
    return {
      isMobile,
      isMobileOnly,
      isTablet,
      switchColors: { checked: "#fff", unchecked: "#fff", disabled: "#CCCCCC" },
      colors: { checked: "#42c13e", unchecked: "#fd3e3e" },
      expiredColors: { checked: "rgb(66, 193, 62)", unchecked: "#2C4BFF" },
      userRole$: store.getters["authStore/getUserRole"],
      ROLES$: ROLES,
    };
  },
});

new Vue({
  render: (h) => h(App),
  router,
  store,
  vuetify,
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js